import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProjectBlogCard from '../../../components/common/ProjectBlogCard/ProjectBlogCard';
import { FaCode, FaIndustry, FaCoffee, FaLaptopCode, FiUploadCloud, MdFastfood } from '../../../icons/index';
import Images from '../../../assets/images/index';
import styles from "./Project.module.scss";

const projects = [
    {
        id: "nymbleup",
        image: Images.AppProject1,
        category: "Food App",
        title: "NymbleUp",
        CategoryIcon: MdFastfood,
        type: "App",
        description:
            "One app from which anyone from the on office can track and raise a tickets to resolve the issues which arrives. Admin can assign that to user. with photos and videos uploaded in the same app.",
        date: "30",
        month: "May"
    },
    {
        id: "coffeechat",
        image: Images.AppProject2,
        category: "Coffee App",
        title: "CoffeeChat",
        CategoryIcon: FaCoffee,
        type: "App",
        description:
            "We built app features in parallel with the client’s website, syncing updates via version control for live changes.",
        date: "05",
        month: "June"
    },
    {
        id: "asite-field",
        image: Images.AppProject3,
        category: "Field Data",
        title: "Asite Field",
        CategoryIcon: FiUploadCloud,
        type: "App",
        description:
            "Empowering users to manage in-field data and site operations effortlessly through an integrated web and mobile app—everything at their fingertips.",
        date: "21",
        month: "July"
    },
    {
        id: "varn-alluminium",
        image: Images.WebProject1,
        category: "Industry",
        title: "Varn Alluminium",
        CategoryIcon: FaIndustry,
        type: "Web",
        description:
            "Varn delivers precision-engineered aluminum solutions that power the future of modern infrastructure.",
        date: "21",
        month: "June"
    },
    {
        id: "teamflow",
        image: Images.TeamFlow,
        category: "Development",
        title: "TeamFlow Application",
        CategoryIcon: FaCode,
        type: "Web",
        description:
            "TeamFlow is a versatile platform built to empower teams of any size with tools to streamline collaboration.",
        date: "20",
        month: "April"
    },
    {
        id: "addscale",
        image: Images.AddScale2,
        category: "Marketing",
        title: "AddScale",
        CategoryIcon: FaLaptopCode,
        type: "Web",
        description:
            "Adscale revolutionizes digital marketing with AI precision. Create, manage, and optimize campaigns effortlessly across top platforms like Facebook, TikTok, and more.",
        date: "14",
        month: "March"
    }
];

const Project = () => {
    const location = useLocation();
    const [filter, setFilter] = useState("All");

    useEffect(() => {
        if (location.state?.filter) {
            setFilter(location.state.filter);

            const section = document.getElementById("portfolio-projects");
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location.state]);

    const filteredProjects =
        filter === "All"
            ? projects
            : projects.filter(project => project.type === filter);

    return (
        <section
            id="portfolio-projects"
            className={styles.projectSection}
        >
            <div className={styles.heading}>
                <h1>
                    Innovative IT Solutions for <span>Evolving Business Needs</span>
                </h1>
                <p>
                    See how our expert team crafts custom technologies to streamline
                    operations and support long-term growth.
                </p>
            </div>

            <div className={styles.filter}>
                {["All", "App", "Web"].map(option => (
                    <button
                        key={option}
                        className={`${styles.filterButton} ${
                            filter === option ? styles.active : ""
                        }`}
                        onClick={() => setFilter(option)}
                    >
                        {option}
                    </button>
                ))}
            </div>
            
            <div className={styles.container}>
                <div className={styles.grid}>
                    {filteredProjects.map(item => (
                      
                        <ProjectBlogCard key={item.id} {...item} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Project;
